var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMasstabPopup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "MASSTAB_POPUP",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 130,
    height: 133,
    viewBox: "0 0 130 133",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #MASSTAB_POPUP .cls-1, #MASSTAB_POPUP .cls-4, #MASSTAB_POPUP .cls-7 {\n        fill: #fff;\n      }\n\n      #MASSTAB_POPUP .cls-1 {\n        stroke: #707070;\n      }\n\n      #MASSTAB_POPUP .cls-2 {\n        opacity: 0.756;\n        clip-path: url(#clip-path);\n      }\n\n      #MASSTAB_POPUP .cls-3 {\n        fill: #f5f5f5;\n      }\n\n      #MASSTAB_POPUP .cls-5, #MASSTAB_POPUP .cls-6, #MASSTAB_POPUP .cls-9 {\n        fill: none;\n      }\n\n      #MASSTAB_POPUP .cls-5, #MASSTAB_POPUP .cls-6, #MASSTAB_POPUP .cls-7 {\n        stroke: #ff7600;\n      }\n\n      #MASSTAB_POPUP .cls-6 {\n        stroke-dasharray: 2 1;\n      }\n\n      #MASSTAB_POPUP .cls-8 {\n        stroke: none;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1528",
    "data-name": "Rechteck 1528",
    className: "cls-1",
    width: 127,
    height: 133,
    transform: "translate(343 298)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DEMO_DRAWING",
    transform: "translate(-415 -238)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_maskieren_3",
    "data-name": "Gruppe maskieren 3",
    className: "cls-2",
    transform: "translate(75 -60)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_936",
    "data-name": "Gruppe 936",
    transform: "translate(354 274.283)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_331",
    "data-name": "Pfad 331",
    className: "cls-3",
    d: "M139,0H79.214V18.91h.173V47.794h-.173V59.555H52.983V74.083H0v51.368H52.983V139.98H79.214V154.1h59.728v-6.342H85.556V133.638H59.324v-15.22h-6v-37.3h6V65.9H85.556v-18.1h-.173V18.91h.173V6.342h53.386V0ZM.577,124.875V74.66H6.342v50.215Zm6.4,0V74.66h5.708v50.215Zm6.4,0V74.66h5.65v50.215Zm39.377,0H19.6V74.66h33.15ZM83.6,19.2h1.268V47.506H83.6Zm-.577,28.307H81.809V19.2h1.211Zm-1.787,0H79.964V19.2h1.268Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_332",
    "data-name": "Pfad 332",
    className: "cls-4",
    d: "M96.538,176.78v.577a34.443,34.443,0,0,0,34.418-33.727h.058V141.9H95.5v1.73h34.88A33.866,33.866,0,0,1,96.538,176.78Z",
    transform: "translate(-40.442 -60.091)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_937",
    "data-name": "Gruppe 937",
    transform: "translate(225 -38)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linie_1339",
    "data-name": "Linie 1339",
    className: "cls-5",
    y2: 31,
    transform: "translate(194.5 346.5)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_1340",
    "data-name": "Linie 1340",
    className: "cls-6",
    y2: 19,
    transform: "translate(194.5 326.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_333",
    "data-name": "Pfad 333",
    className: "cls-5",
    d: "M1540.743,1911.619l4-4,4,4",
    transform: "translate(-1350.243 -1562)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rechteck_1530",
    "data-name": "Rechteck 1530",
    className: "cls-7",
    transform: "translate(194.243 321.964) rotate(45)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 0.5,
    y: 0.5,
    width: 5,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rechteck_1531",
    "data-name": "Rechteck 1531",
    className: "cls-7",
    transform: "translate(194.243 372.964) rotate(45)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 0.5,
    y: 0.5,
    width: 5,
    height: 5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasstabPopup);
export default __webpack_public_path__ + "static/media/masstab-popup.e9ec28fd37e51d4f03efced4d791adae.svg";
export { ForwardRef as ReactComponent };